import moment from 'moment-timezone';
import type { TransactionsReportDto, TransactionsReportRowDto } from './TransactionsReportDto';
import type { TransactionsReport, TransactionsReportRow } from 'model/TransactionsReport';

const toTimestamp = (row: TransactionsReportRowDto, fallbackTz: string) => {
    const tz = row.timezone || fallbackTz || moment.tz.guess();
    const raw = `${row.transactionDate} ${row.time}`;
    const m = moment.tz(raw, 'YYYY-MM-DD h:mm A', tz);

    return m.isValid() ? m : moment.tz(row.transactionDate, 'YYYY-MM-DD', tz).startOf('day');
};

const n = (v: any) => (Number.isFinite(Number(v)) ? Number(v) : 0);

export const convertToTransactionsReport = (dto: TransactionsReportDto, timeZone: string): TransactionsReport => {
    const rows: TransactionsReportRow[] = (dto?.rows ?? []).map(r => ({
        timestamp: toTimestamp(r, timeZone),

        transactionDate: r.transactionDate,
        time: r.time,
        timeFull: r.timeFull ?? r.time,
        timezone: r.timezone,

        grossSales: n(r.grossSales),
        discounts: n(r.discounts),
        refunds: n(r.refunds),
        netSales: n(r.netSales),
        tax: n(r.tax),
        tip: n(r.tip),
        serviceCharges: n(r.serviceCharges),
        totalCollected: n(r.totalCollected),
        fees: n(r.fees),
        netTotal: n(r.netTotal),

        eventType: r.eventType ?? 'Unknown',
        transactionStatus: r.transactionStatus ?? 'Unknown',
        paymentType: r.paymentType ?? 'Unknown',
        cardPaymentMethod: r.cardPaymentMethod ?? 'Unknown',
        transactionId: r.transactionId ?? '',

        appointmentId: r.appointmentId ?? null,
        customerId: r.customerId ?? null,
        customerName: r.customerName ?? null,
        petName: r.petName ?? null,

        feePercentageRate: n(r.feePercentageRate),
        feeFixedRate: n(r.feeFixedRate),

        location: r.location ?? ''
    }));

    rows.sort((a, b) => b.timestamp.valueOf() - a.timestamp.valueOf());

    return {
        meta: {
            page: n(dto?.meta?.page) || 1,
            perPage: n(dto?.meta?.per_page) || 10,
            totalCount: n(dto?.meta?.total_count),
            totalPages: n(dto?.meta?.total_pages) || 1
        },
        totals: {
            grossSales: n(dto?.totals?.gross_sales),
            discounts: n(dto?.totals?.discounts),
            refunds: n(dto?.totals?.refunds),
            netSales: n(dto?.totals?.net_sales),
            tax: n(dto?.totals?.tax),
            tip: n(dto?.totals?.tip),
            serviceCharges: n(dto?.totals?.service_charges),
            totalCollected: n(dto?.totals?.total_collected),
            fees: n(dto?.totals?.fees),
            netTotal: n(dto?.totals?.net_total)
        },
        rows
    };
};
